// extracted by mini-css-extract-plugin
export default {"layout":"layout__77dc1e04"};